import { render, staticRenderFns } from "./ManualAllocationView.vue?vue&type=template&id=4814cd28&scoped=true&"
import script from "./ManualAllocationView.vue?vue&type=script&lang=js&"
export * from "./ManualAllocationView.vue?vue&type=script&lang=js&"
import style0 from "./ManualAllocationView.vue?vue&type=style&index=0&id=4814cd28&scoped=true&lang=css&"
import style1 from "./ManualAllocationView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814cd28",
  null
  
)

component.options.__file = "ManualAllocationView.vue"
export default component.exports